/**
 * Deutsche Zahlformatierung. Referenz: window.de im Clickdummy.
 *
 * Bewusst kein Intl.NumberFormat: der Clickdummy rundet ueber toFixed und
 * ersetzt nur den Dezimalpunkt. Ein Tausenderpunkt wuerde bei Betraegen bis
 * 200 EUR ohnehin nie auftauchen, aber die Zahlen sollen exakt so aussehen wie
 * im abgenommenen Entwurf.
 */
export function de(value: number, decimals = 2): string {
    return (Number(value) || 0).toFixed(decimals).replace('.', ',')
}

/** Betrag mit Vorzeichen, z. B. "+9,00 €" oder "−10,00 €". */
export function signedEuro(value: number, decimals = 2): string {
    // Echtes Minuszeichen (U+2212) statt Bindestrich - so steht es im Clickdummy.
    // Genau null bekommt kein Vorzeichen: "+0,00 EUR" las sich wie ein winziger
    // Gewinn, obwohl gar nichts passiert ist (WETTBANDIT-68).
    const sign = value === 0 ? '' : value > 0 ? '+' : '−'

    return `${sign}${de(Math.abs(value), decimals)} €`
}

export function euro(value: number, decimals = 2): string {
    return `${de(value, decimals)} €`
}
